import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/** Keeps old /parking-sessions/disputes/:id bookmarks working. */
export default function RedirectLegacyDispute() {
  const { disputeId } = useParams<{ disputeId: string }>();
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const to = `/transactions/disputes/${disputeId ?? ''}${qs ? `?${qs}` : ''}`;
  return <Navigate to={to} replace />;
}
